export default __webpack_public_path__ + "static/media/wolf.cfdc4432.png";